import React from "react";
import { GetServerSideProps } from "next";
import { PageMeComp, ssrMe } from "src/generated/page";
import Authorization from "src/components/Authorization/Auhtorization";

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { props } = await ssrMe.getServerPage({}, ctx, true);

  if (props.data.pilotMe) {
    return {
      redirect: {
        destination: "/pilot/dashboard",
        permanent: true,
      },
    };
  }
  return { props };
};

const SignIn: PageMeComp = () => {
  return <Authorization header="Sign In" />;
};

export default SignIn;
